var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"update:page":_vm.goToPage,"update:perPage":_vm.updatePerPage}},'component',_vm.componentProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }